import { reduxKey } from './constants';
import { getGallectionStreamId, isGallectionManageable, getBrowseDeviationStreamId, getGallectionDeviationStreamId, getCustomDeviationSetStreamId, areGallectionContentsManageable, getPostStreamIdFromMediaSource, getTierStreamId, getTierDeviationsStreamId, getGallectionSchemaByType, getCommissionStreamId } from './helpers';
import { selectors } from '../Stream';
import { getDenormalizedDataEntityById, getDenormalizedDataEntitiesByIds } from '../redux/entities/selectors';
import { MediaSourceType } from './types';
import { SCRAPS_FOLDER_ID } from '@wix/da-url';
import { getDeviationsByIds, getDeviationById } from '../redux/deviations/selectors';
import { DeviationResourceType } from '../types/deviation';
const getState = (state)=>state[reduxKey];
export const getMode = (state)=>getState(state).mode;
export const getCurrentMediaSource = (state)=>getState(state).currentMediaSource;
export const getMediaSourceTypes = (state)=>getState(state).mediaSourceTypes;
export const getWithMediaSourceSelector = (state)=>getState(state).withMediaSourceSelector;
export const getCurrentFolderId = (state)=>getState(state).currentFolderId;
export const getCurrentTierId = (state)=>getState(state).currentTierId;
export const getCurrentTier = (state)=>{
    const tierId = getCurrentTierId(state);
    if (tierId) {
        return getTierDeviationById(state, tierId);
    }
};
export const getTierDeviationById = (state, tierId)=>getDeviationById(state, `${DeviationResourceType.TIER}-${tierId}`);
export const getCurrentSubfolderId = (state)=>getState(state).currentSubfolderId;
export const getSearchInput = (state)=>getState(state).searchInput;
export const getSearchQuery = (state)=>getState(state).searchQuery;
export const getAllowedDeviationTypes = (state)=>getState(state).allowedDeviationTypes;
export const getAllowedDeviationResourceTypes = (state)=>getState(state).allowedDeviationResourceTypes;
export const getAllowGifs = (state)=>getState(state).allowGifs;
export const getAllowPremium = (state)=>getState(state).allowPremium;
export const getAllowInTierContent = (state)=>getState(state).allowInTierContent;
export const getAllowMature = (state)=>getState(state).allowMature;
export const getAllowUploads = (state)=>getState(state).allowUploads;
export const getAllowMultipleUploads = (state)=>getState(state).allowMultipleUploads;
export const getIgnoreDeviationIds = (state)=>getState(state).ignoreDeviationIds;
export const getMinDeviationWidth = (state)=>getState(state).minDeviationWidth;
export const getMinDeviationHeight = (state)=>getState(state).minDeviationHeight;
export const getCurrentGallection = (state)=>{
    const currentFolderId = getCurrentFolderId(state);
    return getGallectionById(state, currentFolderId);
};
export const getCurrentSubfolder = (state)=>{
    const currentSubfolderId = getCurrentSubfolderId(state);
    return getGallectionById(state, currentSubfolderId);
};
export const getCurrentStreamId = (state)=>{
    const mediaSource = getCurrentMediaSource(state);
    let streamId = '';
    switch(mediaSource){
        case MediaSourceType.GALLERY:
        case MediaSourceType.COLLECTION:
        case MediaSourceType.STASH:
            const folderId = getCurrentFolderId(state);
            if (folderId) {
                const subfolderId = getCurrentSubfolderId(state);
                streamId = getGallectionDeviationStreamId(mediaSource, subfolderId || folderId);
            } else {
                streamId = getGallectionStreamId(mediaSource);
            }
            break;
        case MediaSourceType.POLL:
        case MediaSourceType.STATUS:
        case MediaSourceType.JOURNAL:
        case MediaSourceType.POSTS:
            streamId = getPostStreamIdFromMediaSource(mediaSource);
            break;
        case MediaSourceType.BROWSE:
            streamId = getBrowseDeviationStreamId(getSearchQuery(state));
            break;
        case MediaSourceType.CUSTOM_SET:
            streamId = getCustomDeviationSetStreamId();
            break;
        case MediaSourceType.TIER_DEVIATIONS:
        case MediaSourceType.TIER_POSTS:
            const tierId = getCurrentTierId(state);
            streamId = getTierDeviationsStreamId(mediaSource, tierId);
            break;
        default:
    }
    return streamId;
};
export const getCurrentStreamItems = (state)=>{
    const streamId = getCurrentStreamId(state);
    return selectors.getItems(state, streamId);
};
export const getGallectionById = (state, folderId)=>{
    const currentMediaSource = getCurrentMediaSource(state);
    if (!currentMediaSource || !folderId) {
        return;
    }
    const gallectionSchema = getGallectionSchemaByType(currentMediaSource);
    return getDenormalizedDataEntityById(state, gallectionSchema, folderId);
};
export const getIsShowingNewGallectionPopup = (state)=>getState(state).isShowingNewGallectionPopup;
export const getIsShowingAddDeviationsPopup = (state)=>getState(state).isShowingAddDeviationsPopup;
export const getIsOnlyPaidFoldersSelector = (state)=>getState(state).onlyNewPaidFolders;
export const getSelectionLimit = (state)=>getState(state).selectionLimit;
export const getSelectedDeviationIds = (state)=>getState(state).selectedDeviationEntityIds;
export const getUsername = (state)=>getState(state).username;
export const getAllGallections = (state)=>{
    const mediaSource = getCurrentMediaSource(state);
    const topLevelGallectionIds = getTopLevelGallectionIds(state);
    let allGallectionIds = [];
    topLevelGallectionIds.forEach((topLevelGallectionId)=>{
        const subfoldersStreamId = getGallectionStreamId(mediaSource, topLevelGallectionId);
        const subfoldersIds = selectors.getItems(state, subfoldersStreamId);
        allGallectionIds = [
            ...allGallectionIds,
            topLevelGallectionId,
            ...subfoldersIds
        ];
    });
    const gallectionSchema = getGallectionSchemaByType(mediaSource);
    const allGallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, allGallectionIds);
    return allGallections;
};
export const getTopLevelGallectionIds = (state)=>{
    const mediaSource = getCurrentMediaSource(state);
    const streamId = getGallectionStreamId(mediaSource);
    const topLevelGallectionIds = selectors.getItems(state, streamId);
    return topLevelGallectionIds;
};
export const hasGallectionsToCopyOrMoveTo = (state, currentFolderId)=>{
    return !!getTopLevelGallections(state).filter((gallection)=>areGallectionContentsManageable(gallection) && gallection.folderId !== currentFolderId).length;
};
export const getTopLevelGallections = (state)=>{
    const mediaSource = getCurrentMediaSource(state);
    const streamId = getGallectionStreamId(mediaSource);
    const gallectionSchema = getGallectionSchemaByType(mediaSource);
    const gallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, selectors.getItems(state, streamId));
    return gallections;
};
export const getTiers = (state)=>{
    const streamId = getTierStreamId();
    const streamItems = selectors.getItems(state, streamId);
    const tiers = getDeviationsByIds(state, streamItems);
    return tiers;
};
export const getCommissions = (state)=>{
    const streamId = getCommissionStreamId();
    const streamItems = selectors.getItems(state, streamId);
    const commissions = getDeviationsByIds(state, streamItems);
    return commissions;
};
export const getFeaturedFolder = (state)=>(getTopLevelGallections(state) || []).find((folder)=>folder.name === 'Featured');
export const getCurrentGallectionSubfolders = (state)=>{
    const currentGallection = getCurrentGallection(state);
    if (!currentGallection) {
        return [];
    }
    return getSubfoldersByParentId(state, currentGallection.folderId);
};
export const getSubfoldersByParentId = (state, parentId)=>{
    const mediaSource = getCurrentMediaSource(state);
    const streamId = getGallectionStreamId(mediaSource, parentId);
    const gallectionSchema = getGallectionSchemaByType(mediaSource);
    const gallectionIds = selectors.getItems(state, streamId);
    const gallections = getDenormalizedDataEntitiesByIds(state, gallectionSchema, gallectionIds);
    return gallections;
};
export const getTotalDeviationsCountByFolderId = (state, folderId)=>{
    const folder = getGallectionById(state, folderId);
    if (!folder) {
        return 0;
    }
    const subfolders = getSubfoldersByParentId(state, folderId);
    const subfolderDeviationsCount = subfolders ? subfolders.reduce((prevValue, subfolder)=>prevValue + subfolder.size, 0) : 0;
    return folder.size + subfolderDeviationsCount;
};
// Be aware this is not how it's stored on the BE e.g.:
// * All is an artificial folder that doesn't really exist
// * Scraps goes last only in the UI, on the BE it takes the first spot
export const getNonManageablePrependedGallectionsCount = (state)=>{
    const gallections = getTopLevelGallections(state);
    const currentFolderId = getCurrentFolderId(state);
    if (!gallections || currentFolderId // there's no non-manageable gallections on subfolder level
    ) {
        return 0;
    }
    return gallections.filter((gallection)=>!isGallectionManageable(gallection) && gallection.folderId !== SCRAPS_FOLDER_ID // Scraps is an exception -- it always goes last
    ).length;
};
export const streamHasScrapsFolder = (state, streamId)=>{
    const gallectionIds = selectors.getItems(state, streamId);
    return gallectionIds.some((id)=>id === SCRAPS_FOLDER_ID);
};
